// import { CSSProperties } from '@material-ui/core/styles/withStyles';
//
import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import Link from 'next/link';
import promotionResultsPage from '~/assets/images/promotionResultsPage.svg';
import { COLORS } from '~/data/ui/colors';
import theme, { extraThinMobileWidth, thinMobileWidth } from '~/theme';

const useStyles = () => ({
  root: {
    border: `1px solid ${COLORS.gray.dark5}`,
    borderRadius: '8px',
    background: 'white',
    position: 'relative',
    transition: 'all 0.16s ease',
    '&:hover': {
      border: `1px solid transparent`,
      boxShadow: `0 0 0 2px ${COLORS.primary.main}`,
    },
    width: '100%',
    [theme.breakpoints.up('md')]: {
      height: '100%',
    },
  },
  '& .carousel .control-dots .dot.selected, .carousel .control-dots .dot:hover ':
    {
      opacity: 1,
      backgroundColor: 'yellow',
    },

  cardContainer: {
    padding: '12px 16px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },

  topLabelWidget: {
    minHeight: '27px',
    marginTop: '12px',
  },
  sliderContainer: {
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    cursor: 'grab',
    '&:active': {
      cursor: 'grabbing',
    },
  },
  specialPriceIcon: {
    position: 'absolute',
    right: '8px',
    top: '12px',
    cursor: 'pointer',
  },

  wishlistIcon: {
    display: 'flex',
    gap: '12px',
    position: 'absolute',
    left: '8px',
    top: '12px',
    cursor: 'pointer',
    justifyContent: 'center',
    alignItems: 'center',
  },
  bottomLabel: {
    display: 'flex',
    position: 'absolute',
    right: -16,
    top: '12px',
    justifyContent: 'center',
    alignItems: 'center',
  },

  priceWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    gap: '3px',
    marginTop: '12px',
  },

  exposedPriceWrapper: {
    backgroundColor: COLORS.primary.light2,
    padding: '5px 8px',
    gap: '3px',
    position: 'relative',
    marginTop: '21px',
    borderRadius: '4px',
    marginBottom: 'unset',
  },

  toolTipButton: {
    border: 'none',
    fontFamily: 'EricaSansFOT,GillSans',
    fontWeight: '800',
    backgroundColor: 'transparent',
    color: `${COLORS.primary.dark2}`,
    fontSize: '18px',
    cursor: 'pointer',
    '&.MuiTypography-root': {
      fontSize: '16px',
    },
  },

  toolTipWrapper: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: '14px',
  },
  upSaleIcon: {
    position: 'absolute',
    left: '130px',
    bottom: '2px',
    zIndex: '-100',
  },

  goToCarButton: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    marginTop: '17px',
    width: '-webkit-fill-available',
  },

  upsaleText: {
    '&.MuiTypography-root': {
      fontSize: '16px',
    },
  },

  promotionStyle: {
    backgroundImage: `url(${promotionResultsPage.src})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    position: 'absolute',
    height: '250px',
    width: '100%',
    top: '0',
  },

  subscriptionBackgroundStyle: {
    position: 'absolute',
    left: '35px',
    top: '0px',
  },
  subscriptionModelNameSpacer: {
    marginTop: '48px',
  },
  carNextUrlStyle: {
    textDecoration: 'none',
    flex: 1,
  },
  btnsDivStyle: {
    display: 'flex',
    flexDirection: 'row',
    gap: '12px',
  },
  fomoContainer: {
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    marginTop: '12px',
    position: 'relative',
    gap: '6px',
    [theme.breakpoints.down('md')]: {
      marginTop: '10px',
    },
  },
});

export default useStyles;

export const CarNextUrlStyle = styled(Link)(() => ({
  display: 'flex',
  flexDirection: 'column',
  textDecoration: 'none',
  flex: 1,
  gap: '8px',
}));

export const StyledFomoIcon = styled('svg')(() => ({
  width: '18px',
  height: '18px',
  marginRight: '8px',
}));

export const brandNameStyle = {
  marginTop: '10px',
  fontSize: '16px',
};

export const modelNameStyle = {
  marginTop: '4px',
  fontSize: '24px',
  width: '100%',
  lineHeight: '24px',
  textTransform: 'uppercase',
  fontFamily: 'EricaSansFOT,GillSans',
  fontWeight: '800',
};

export const buttonStyle = {
  width: '100%',
  marginTop: '8px',
  flexDirection: 'row-reverse',
  fontSize: '16px',
  gap: '5px',
};
export const priceStyle = {
  fontSize: '32px',
  fontFamily: 'EricaSansFOT,GillSans',
  fontWeight: '800',
  position: 'relative',
  lineHeight: 'normal',
  zIndex: '1',
  display: 'flex',
  alignItems: 'end',
  gap: '5px',
};

export const exposedPriceStyle = {
  paddingRight: '5px',
};
export const priceListStyle = {
  fontSize: '16px',
  minWidth: '200px',
};

export const priceListCarCardStyle = {
  fontSize: '16px',
  lineHeight: 'normal',
  minHeight: '16px',
};

export const purchasingDetailsStyle = {
  fontFamily: 'EricaSansFOT',
  fontWeight: 400,
  fontSize: '14px',
  textAlign: 'right',
  color: COLORS.black.main,
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  margin: '12px 0 9px',
};

export const purchasingDetailsDotStyle = {
  color: COLORS.primary.main,
};
export const CarImagesCarouselStyle = {
  background: `${COLORS.white.main}`,
};

export const toExposePrice = {
  backgroundColor: `${COLORS.yellow.light1}`,
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  width: '100%',
  fontWeight: '400',
  borderRadius: '4px',
  '&.MuiTypography-root': {
    padding: '6.3px',
    fontSize: '16px',
    [theme.breakpoints.down('md')]: {
      fontSize: '13px',
    },
  },
};

export const contactUsButton = {
  flex: 1,
  padding: 0,
  marginTop: '8px',
};
export const contactUsButtonText = {
  fontWeight: '400',
};

export const saleTopLabel = {
  backgroundColor: COLORS.yellow.main,
  fontWeight: 'bold',
};

export const labelStyles = {
  padding: '5px 6px',
  backgroundColor: COLORS.gray.light,
  borderRadius: '3px',
};

export const yellowLineContainerStyles = {
  position: 'absolute',
  right: '7px',
  maxWidth: '70%',
  top: '11px',
  zIndex: '-1',
};

export const priceWrapperStyles = {
  position: 'absolute',
  right: '0',
  zIndex: '-1',
  width: '105%',
  bottom: '-8px',
};
export const yellowLineStyles = { maxWidth: '100%' };

export const bottomContainer = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  position: 'relative',
  gap: '8px',
};

export const contentContainer = {
  marginBottom: 'auto',
};
export const bulletsContainer = {
  marginBottom: '29px',
};
export const bulletContainer = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  [theme.breakpoints.down(extraThinMobileWidth)]: {
    maxWidth: '200px',
  },
};
export const StyledBulletIcon = styled('svg')(() => ({
  maxWidth: '15px',
}));
export const bulletTextStyles = {
  fontSize: '14px',
  color: COLORS.gray.dark,
  [theme.breakpoints.down(thinMobileWidth)]: {
    fontSize: '13px',
    lineHeight: 'normal',
  },
};

export const DiscountLabel = styled(Typography)(() => ({
  fontFamily: 'EricaSansFOT',
  fontSize: '14px',
  fontWeight: 'bold',
  lineHeight: '16px',
  padding: '3px 6px',
  textAlign: 'right',
  borderRadius: '34px',
  backgroundColor: COLORS.yellow.dark4,
}));

export const tooltipCustomStyles = {
  maxWidth: '16px',
  padding: '0',
  marginRight: '8px',
};
export const bottomPriceContainer = { display: 'flex', alignItems: 'center' };

export const StyledOnlinePriceImage = styled('svg')(() => ({
  bottom: '3.75rem',
  position: 'absolute',
  left: '0',
  maxWidth: '105px',
  [theme.breakpoints.down(thinMobileWidth)]: {
    maxWidth: '90px',
  },
}));

export const normalPriceStyle = {
  textDecoration: 'line-through',
  fontWeight: '400',
  fontSize: '16px',
};

export const exposePriceContainer = {
  display: 'flex',
  gap: '5px',
  marginBottom: '10px',
  alignItems: 'center',
  fontSize: '16px',
};

export const StyledOnlinePriceTag = styled('svg')(() => ({
  position: 'absolute',
  left: '-20px',
  top: '-5px',
  maxWidth: '80px',
  overflow: 'visible',
}));

export const customWishlistStyles = {
  minWidth: 'unset',
  border: '.5px solid black',
  borderRadius: '50%',
  padding: '8px',
  width: '32px',
  height: '32px',
};

export const customCompareButton = {
  width: '32px',
  zIndex: '1',
};

export const topLabelStyles = { backgroundColor: COLORS.yellow.light1 };
